export default __webpack_public_path__ + "static/0303-008b00f6c08961eaa22367f5fa6194c5.png";